module.exports = __webpack_public_path__ + "media/images/mobile/solutions/11-9b18b1b7cd3f8e00a09a9c9e308337aa.png";